import {
  BUNDLED_COACH_GLB,
  BUNDLED_STUDENT_FEMALE_GLB,
  BUNDLED_STUDENT_GLB,
  BUNDLED_STUDENT_MALE_GLB,
  probeFullBodyGlb,
  probeModelUrl,
} from "@/lib/classroom/fitAvatarToFloor";
import type { DefaultAvatarGender } from "@/data/types/classroom";

export {
  BUNDLED_COACH_GLB,
  BUNDLED_STUDENT_GLB,
  BUNDLED_STUDENT_FEMALE_GLB,
  BUNDLED_STUDENT_MALE_GLB,
  probeFullBodyGlb,
  probeModelUrl,
};

const RPM_MODELS_BASE = "https://models.readyplayer.me";

export const FALLBACK_VRM_FEMALE = "/models/avatar-cute.vrm";
export const FALLBACK_VRM_MALE = "/models/avatar-male.vrm";
export const FALLBACK_INSTRUCTOR_VRM = "/models/avatar-coach.vrm";
export const FALLBACK_VRM_MODEL = FALLBACK_VRM_FEMALE;
export const VIDEO_HEAD_GLB_MODEL = "/models/avatar-default.glb";

export function buildReadyPlayerMeUrl(avatarId: string): string {
  return `${RPM_MODELS_BASE}/${avatarId}.glb?morphTargets=ARKit&textureAtlas=1024`;
}

export const DEFAULT_CLASSROOM_AVATAR_URL = FALLBACK_VRM_FEMALE;
export const DEFAULT_INSTRUCTOR_AVATAR_URL = FALLBACK_INSTRUCTOR_VRM;

export function resolveStudentFallbackVrm(
  gender: DefaultAvatarGender = "female"
): string {
  return gender === "male" ? FALLBACK_VRM_MALE : FALLBACK_VRM_FEMALE;
}

export function resolveStudentBundledGlb(
  gender: DefaultAvatarGender = "female"
): string {
  return gender === "male"
    ? BUNDLED_STUDENT_MALE_GLB
    : BUNDLED_STUDENT_FEMALE_GLB;
}

export function isReadyPlayerMeUrl(url: string): boolean {
  return url.includes("readyplayer.me");
}

export function isVrmModelUrl(url: string): boolean {
  return url.toLowerCase().endsWith(".vrm");
}

export function isBundledQualityGlb(url: string): boolean {
  return (
    url === BUNDLED_STUDENT_GLB ||
    url === BUNDLED_STUDENT_FEMALE_GLB ||
    url === BUNDLED_STUDENT_MALE_GLB ||
    url === BUNDLED_COACH_GLB
  );
}

export function withArkitMorphTargets(url: string): string {
  if (!isReadyPlayerMeUrl(url)) return url;
  if (url.includes("morphTargets=")) return url;
  return `${url}${url.includes("?") ? "&" : "?"}morphTargets=ARKit`;
}

export function resolveClassroomAvatarUrl(
  virtualAvatarUrl?: string | null,
  bundledFallback?: string | null
): string {
  const trimmed = virtualAvatarUrl?.trim();
  // Ready Player Me 서비스가 종료되어 원격 URL은 내장 모델로 폴백합니다.
  if (trimmed && !isReadyPlayerMeUrl(trimmed)) {
    return withArkitMorphTargets(trimmed);
  }
  if (bundledFallback) return bundledFallback;
  return DEFAULT_CLASSROOM_AVATAR_URL;
}

export function shouldApplyAvatarCustomization(
  modelUrl: string,
  nativeMaterials = false
): boolean {
  if (nativeMaterials) return false;
  if (isReadyPlayerMeUrl(modelUrl)) return false;
  if (modelUrl.toLowerCase().endsWith(".glb")) return false;
  if (isBundledQualityGlb(modelUrl)) return false;
  return isVrmModelUrl(modelUrl);
}
